import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { I18NextService } from 'angular-i18next';

/** What the user wants to create as the reclassification target. */
export type ReclassNewTargetKind = 'ACCOUNT' | 'GROUP';

/**
 * The first step behind the reclassification modal's "+" button: create an ACCOUNT or a GROUP.
 *
 * Modelled on the super-table's calculation-type picker (two large icon buttons in a `ham-modal`)
 * because that is the established way this app asks "which of these do you want to add?" — the user
 * has met the pattern before, and the option stays visibly selected after the click while the
 * follow-up dialog opens.
 *
 * Only the choice lives here; each branch's form is its own nested modal.
 */
@Component({
    selector: 'aumico-reclass-new-target-choice',
    templateUrl: './reclass-new-target-choice.component.html',
    styleUrls: ['./reclass-new-target-choice.component.scss'],
})
export class ReclassNewTargetChoiceComponent implements OnInit {
    @Output() chosen = new EventEmitter<ReclassNewTargetKind>();

    selectedOption: ReclassNewTargetKind | undefined;

    prompt = '';
    accountOptionLabel = '';
    groupOptionLabel = '';

    constructor(private readonly i18n: I18NextService) {}

    ngOnInit(): void {
        const t = (k: string): string => this.i18n.t(k) as string;
        this.prompt = t('aumico_grouping_masking_reclass_new_target_choice_prompt');
        this.accountOptionLabel = t('aumico_grouping_masking_reclass_new_target_choice_account');
        this.groupOptionLabel = t('aumico_grouping_masking_reclass_new_target_choice_group');
    }

    onChoose(kind: ReclassNewTargetKind): void {
        this.selectedOption = kind;
        this.chosen.emit(kind);
    }
}
